/* Generated by ai2react v0.102.0 - 2021-09-14 03:18 */
/* ai file: 03-qs-world-chilenos.ai */

import { makeAi2React } from './src/index'
import img0 from './img/03-qs-world-chilenos-large.svg'
import img1 from './img/03-qs-world-chilenos-mobile.svg'

const styles = `
  #g-03-qs-world-chilenos-box ,
  #g-03-qs-world-chilenos-box .g-artboard {
    margin:0 auto;
  }
  #g-03-qs-world-chilenos-box p {
    margin:0;
  }
  #g-03-qs-world-chilenos-box .g-aiAbs {
    position:absolute;
  }
  #g-03-qs-world-chilenos-box .g-aiImg {
    position:absolute;
    top:0;
    display:block;
    width:100% !important;
  }
  #g-03-qs-world-chilenos-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-03-qs-world-chilenos-box .g-aiPointText p { white-space: nowrap; }
  #g-03-qs-world-chilenos-large {
    position:relative;
    overflow:hidden;
  }
  #g-03-qs-world-chilenos-large p {
    font-family:Inter;
    font-weight:400;
    line-height:12px;
    height:auto;
    filter:alpha(opacity=100);
    -ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity:1;
    letter-spacing:-0.029em;
    font-size:10px;
    text-align:left;
    color:rgb(0,0,0);
    text-transform:none;
    padding-bottom:0;
    padding-top:0;
    mix-blend-mode:normal;
    font-style:normal;
    position:static;
  }
  #g-03-qs-world-chilenos-large .g-pstyle0 {
    font-weight:800;
    line-height:21px;
    height:21px;
    letter-spacing:-0.02em;
    font-size:18px;
  }
  #g-03-qs-world-chilenos-large .g-pstyle1 {
    font-weight:700;
    line-height:13px;
    height:13px;
    letter-spacing:-0.019em;
    font-size:11px;
    color:rgb(252,184,19);
  }
  #g-03-qs-world-chilenos-large .g-pstyle2 {
    font-weight:700;
    line-height:11px;
    height:11px;
    letter-spacing:-0.02em;
    font-size:9px;
  }
  #g-03-qs-world-chilenos-large .g-pstyle3 {
    font-weight:700;
    line-height:10px;
    height:10px;
    letter-spacing:-0.019em;
    font-size:8px;
  }
  #g-03-qs-world-chilenos-large .g-pstyle4 {
    height:12px;
  }
  #g-03-qs-world-chilenos-large .g-pstyle5 {
    line-height:11px;
    height:11px;
    letter-spacing:-0.03em;
    font-size:9px;
  }
  #g-03-qs-world-chilenos-large .g-pstyle6 {
    line-height:11px;
    height:11px;
    font-size:9px;
  }
  #g-03-qs-world-chilenos-large .g-pstyle7 {
    line-height:10px;
    height:10px;
    letter-spacing:0em;
    font-size:8px;
    color:rgb(255,255,255);
  }
  #g-03-qs-world-chilenos-large .g-pstyle8 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.019em;
    font-size:8px;
    color:rgb(255,255,255);
  }
  #g-03-qs-world-chilenos-large .g-pstyle9 {
    line-height:13px;
    height:13px;
    font-size:11px;
  }
  #g-03-qs-world-chilenos-large .g-cstyle0 {
    letter-spacing:-0.019em;
  }
  #g-03-qs-world-chilenos-large .g-cstyle1 {
    letter-spacing:0em;
  }
  #g-03-qs-world-chilenos-large .g-cstyle2 {
    letter-spacing:-0.02em;
  }
  #g-03-qs-world-chilenos-large .g-cstyle3 {
    letter-spacing:-0.03em;
  }
  #g-03-qs-world-chilenos-large .g-cstyle4 {
    letter-spacing:-0.032em;
  }
  #g-03-qs-world-chilenos-large .g-cstyle5 {
    letter-spacing:-0.029em;
  }
  #g-03-qs-world-chilenos-large .g-cstyle6 {
    letter-spacing:0.213em;
  }
  #g-03-qs-world-chilenos-large .g-cstyle7 {
    letter-spacing:-0.05em;
  }
  #g-03-qs-world-chilenos-large .g-cstyle8 {
    letter-spacing:-0.033em;
  }
  #g-03-qs-world-chilenos-large .g-cstyle9 {
    letter-spacing:-0.037em;
  }
  #g-03-qs-world-chilenos-large .g-cstyle10 {
    letter-spacing:-0.116em;
  }
  #g-03-qs-world-chilenos-large .g-cstyle11 {
    letter-spacing:-0.11em;
  }
  #g-03-qs-world-chilenos-large .g-cstyle12 {
    letter-spacing:-0.044em;
  }
  #g-03-qs-world-chilenos-large .g-cstyle13 {
    letter-spacing:-0.034em;
  }
  #g-03-qs-world-chilenos-large .g-cstyle14 {
    letter-spacing:-0.035em;
  }
  #g-03-qs-world-chilenos-mobile {
    position:relative;
    overflow:hidden;
  }
  #g-03-qs-world-chilenos-mobile p {
    font-family:Inter;
    font-weight:400;
    line-height:13px;
    height:auto;
    filter:alpha(opacity=100);
    -ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity:1;
    letter-spacing:-0.029em;
    font-size:11px;
    text-align:left;
    color:rgb(0,0,0);
    text-transform:none;
    padding-bottom:0;
    padding-top:0;
    mix-blend-mode:normal;
    font-style:normal;
    position:static;
  }
  #g-03-qs-world-chilenos-mobile .g-pstyle0 {
    font-weight:800;
    line-height:21px;
    height:21px;
    letter-spacing:-0.02em;
    font-size:18px;
  }
  #g-03-qs-world-chilenos-mobile .g-pstyle1 {
    font-weight:700;
    line-height:15px;
    height:15px;
    letter-spacing:-0.019em;
    font-size:12px;
    color:rgb(252,184,19);
  }
  #g-03-qs-world-chilenos-mobile .g-pstyle2 {
    font-weight:700;
    height:13px;
    letter-spacing:-0.02em;
  }
  #g-03-qs-world-chilenos-mobile .g-pstyle3 {
    font-weight:700;
    line-height:11px;
    height:11px;
    letter-spacing:-0.019em;
    font-size:9px;
  }
  #g-03-qs-world-chilenos-mobile .g-pstyle4 {
    height:13px;
  }
  #g-03-qs-world-chilenos-mobile .g-pstyle5 {
    height:13px;
    letter-spacing:-0.03em;
  }
  #g-03-qs-world-chilenos-mobile .g-pstyle6 {
    height:13px;
    letter-spacing:-0.03em;
    font-size:10px;
  }
  #g-03-qs-world-chilenos-mobile .g-pstyle7 {
    line-height:11px;
    height:11px;
    letter-spacing:0em;
    font-size:9px;
    color:rgb(255,255,255);
  }
  #g-03-qs-world-chilenos-mobile .g-pstyle8 {
    height:13px;
    font-size:10px;
  }
  #g-03-qs-world-chilenos-mobile .g-pstyle9 {
    line-height:11px;
    height:11px;
    letter-spacing:-0.019em;
    font-size:9px;
    color:rgb(255,255,255);
  }
  #g-03-qs-world-chilenos-mobile .g-cstyle0 {
    letter-spacing:-0.019em;
  }
  #g-03-qs-world-chilenos-mobile .g-cstyle1 {
    letter-spacing:0em;
  }
  #g-03-qs-world-chilenos-mobile .g-cstyle2 {
    letter-spacing:-0.02em;
  }
  #g-03-qs-world-chilenos-mobile .g-cstyle3 {
    letter-spacing:-0.03em;
  }
  #g-03-qs-world-chilenos-mobile .g-cstyle4 {
    letter-spacing:-0.032em;
  }
  #g-03-qs-world-chilenos-mobile .g-cstyle5 {
    letter-spacing:-0.029em;
  }
  #g-03-qs-world-chilenos-mobile .g-cstyle6 {
    letter-spacing:-0.033em;
  }
  #g-03-qs-world-chilenos-mobile .g-cstyle7 {
    letter-spacing:0.213em;
  }
  #g-03-qs-world-chilenos-mobile .g-cstyle8 {
    letter-spacing:-0.05em;
  }
  #g-03-qs-world-chilenos-mobile .g-cstyle9 {
    letter-spacing:-0.116em;
  }
  #g-03-qs-world-chilenos-mobile .g-cstyle10 {
    letter-spacing:-0.037em;
  }
  #g-03-qs-world-chilenos-mobile .g-cstyle11 {
    letter-spacing:-0.11em;
  }
  #g-03-qs-world-chilenos-mobile .g-cstyle12 {
    letter-spacing:-0.044em;
  }
  #g-03-qs-world-chilenos-mobile .g-cstyle13 {
    letter-spacing:-0.034em;
  }
  #g-03-qs-world-chilenos-mobile .g-cstyle14 {
    letter-spacing:-0.035em;
  }

`

const html = props => `
<div id="g-03-qs-world-chilenos-box" class="ai2html">


  <!-- Artboard: large -->
  <div id="g-03-qs-world-chilenos-large" class="g-artboard" style="width:800px; height:457px;" data-aspect-ratio="1.751" data-min-width="800">
<div style=""></div>
    <img id="g-03-qs-world-chilenos-large-img" class="g-aiImg" alt="" src="${img0}"/>
    <div id="g-ai0-1" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:3.2685%;margin-top:-11.9px;left:0.4667%;width:367px;">
      <p class="g-pstyle0">QS <span class="g-cstyle0">W</span>ORLD<span class="g-cstyle0"> </span>U<span class="g-cstyle0">N</span>IV<span class="g-cstyle0">E</span>RSI<span class="g-cstyle0">TY</span> RANKI<span class="g-cstyle0">N</span>GS 202<span class="g-cstyle1">2</span></p>
    </div>
    <div id="g-ai0-2" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:8.5913%;margin-top:-7.3px;left:7.8031%;width:75px;">
      <p class="g-pstyle1"><span class="g-cstyle2">I</span>ns<span class="g-cstyle2">t</span>i<span class="g-cstyle2">t</span>u<span class="g-cstyle2">c</span>ió<span class="g-cstyle1">n</span></p>
    </div>
    <div id="g-ai0-3" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:8.5913%;margin-top:-7.3px;left:61.0688%;width:75px;">
      <p class="g-pstyle1"><span class="g-cstyle2">I</span>ns<span class="g-cstyle2">t</span>i<span class="g-cstyle2">t</span>u<span class="g-cstyle2">c</span>ió<span class="g-cstyle1">n</span></p>
    </div>
    <div id="g-ai0-4" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:8.439%;margin-top:-6.6px;left:1.0168%;width:66px;">
      <p class="g-pstyle2">RA<span class="g-cstyle0">N</span>KI<span class="g-cstyle0">N</span>G<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-5" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:8.439%;margin-top:-6.6px;left:54.1504%;width:66px;">
      <p class="g-pstyle2">RA<span class="g-cstyle0">N</span>KI<span class="g-cstyle0">N</span>G<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-6" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:8.2868%;margin-top:-5.9px;left:37.5912%;width:50px;">
      <p class="g-pstyle3">Ciuda<span class="g-cstyle1">d</span></p>
    </div>
    <div id="g-ai0-7" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:8.2868%;margin-top:-5.9px;left:90.8569%;width:50px;">
      <p class="g-pstyle3">C<span class="g-cstyle2">i</span>uda<span class="g-cstyle1">d</span></p>
    </div>
    <div id="g-ai0-8" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.4084%;margin-top:-6.6px;left:0.5922%;width:71px;">
      <p class="g-pstyle2"><span class="g-cstyle0">N</span>ACIO<span class="g-cstyle0">N</span>A<span class="g-cstyle1">L</span></p>
    </div>
    <div id="g-ai0-9" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.4084%;margin-top:-6.6px;left:53.7258%;width:71px;">
      <p class="g-pstyle2"><span class="g-cstyle0">N</span>ACIO<span class="g-cstyle0">N</span>A<span class="g-cstyle1">L</span></p>
    </div>
    <div id="g-ai0-10" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.6114%;margin-top:-6.9px;left:7.7948%;width:193px;">
      <p class="g-pstyle4">P<span class="g-cstyle3">on</span>ti<span class="g-cstyle3">f</span>i<span class="g-cstyle3">c</span>i<span class="g-cstyle3">a</span> <span class="g-cstyle4">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">da</span>d C<span class="g-cstyle4">a</span>t<span class="g-cstyle3">ó</span>l<span class="g-cstyle3">i</span>c<span class="g-cstyle3">a d</span>e Ch<span class="g-cstyle3">ile</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-11" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.6114%;margin-top:-6.9px;left:61.0605%;width:146px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d A<span class="g-cstyle3">u</span>str<span class="g-cstyle3">a</span>l d<span class="g-cstyle3">e</span> C<span class="g-cstyle3">h</span>i<span class="g-cstyle3">le</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-12" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.973%;margin-top:-6.6px;left:37.1579%;width:60px;">
      <p class="g-pstyle5"><span class="g-cstyle5">S</span>an<span class="g-cstyle5">t</span>iago<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-13" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.973%;margin-top:-6.6px;left:90.4402%;width:60px;">
      <p class="g-pstyle6"><span class="g-cstyle6"> </span><span class="g-cstyle7">V</span>a<span class="g-cstyle3">l</span>div<span class="g-cstyle3">i</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-14" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.8208%;margin-top:-5.9px;left:3.5505%;width:28px;">
      <p class="g-pstyle7"><span class="g-cstyle0">1</span> </p>
    </div>
    <div id="g-ai0-15" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.8208%;margin-top:-5.9px;left:55.584%;width:45px;">
      <p class="g-pstyle8"><span class="g-cstyle2">1</span>0-<span class="g-cstyle2">1</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-16" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:24.2701%;margin-top:-6.9px;left:7.7948%;width:114px;">
      <p class="g-pstyle4"><span class="g-cstyle8">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span>Chi<span class="g-cstyle3">l</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-17" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:24.2701%;margin-top:-6.9px;left:61.0605%;width:142px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d d<span class="g-cstyle3">e </span>La <span class="g-cstyle9">F</span><span class="g-cstyle8">r</span><span class="g-cstyle3">o</span>nt<span class="g-cstyle3">e</span>ra<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-18" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:24.6316%;margin-top:-6.6px;left:37.1579%;width:60px;">
      <p class="g-pstyle5"><span class="g-cstyle5">S</span>an<span class="g-cstyle5">t</span>iago<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-19" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:24.6316%;margin-top:-6.6px;left:90.2816%;width:62px;">
      <p class="g-pstyle6"><span class="g-cstyle6"> </span><span class="g-cstyle10">T</span>emuc<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-20" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:24.4794%;margin-top:-5.9px;left:3.5258%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle0">2</span> </p>
    </div>
    <div id="g-ai0-21" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:24.4794%;margin-top:-5.9px;left:55.584%;width:45px;">
      <p class="g-pstyle8"><span class="g-cstyle2">1</span>0-<span class="g-cstyle2">1</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-22" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:31.9287%;margin-top:-6.9px;left:7.7948%;width:168px;">
      <p class="g-pstyle4"><span class="g-cstyle8">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span>Sa<span class="g-cstyle3">n</span>t<span class="g-cstyle3">i</span>ag<span class="g-cstyle3">o</span> de <span class="g-cstyle3">C</span>hi<span class="g-cstyle3">l</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-23" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:31.9287%;margin-top:-6.9px;left:61.0605%;width:115px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d d<span class="g-cstyle3">e </span><span class="g-cstyle11">T</span>a<span class="g-cstyle3">lc</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-24" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:32.2902%;margin-top:-6.6px;left:37.1579%;width:60px;">
      <p class="g-pstyle5"><span class="g-cstyle5">S</span>an<span class="g-cstyle5">t</span>iago<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-25" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:32.2902%;margin-top:-6.6px;left:91.0482%;width:50px;">
      <p class="g-pstyle6"><span class="g-cstyle6"> </span><span class="g-cstyle11">T</span>a<span class="g-cstyle3">l</span>ca<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-26" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:32.138%;margin-top:-5.9px;left:3.5341%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle0">3</span> </p>
    </div>
    <div id="g-ai0-27" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:32.138%;margin-top:-5.9px;left:55.584%;width:45px;">
      <p class="g-pstyle8"><span class="g-cstyle2">1</span>0-<span class="g-cstyle2">1</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-28" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.5874%;margin-top:-6.9px;left:7.7948%;width:144px;">
      <p class="g-pstyle4"><span class="g-cstyle8">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span>Co<span class="g-cstyle3">n</span>cep<span class="g-cstyle3">c</span>ió<span class="g-cstyle3">n</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-29" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:39.5874%;margin-top:-6.9px;left:61.0605%;width:137px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d d<span class="g-cstyle3">e </span><span class="g-cstyle7">V</span>a<span class="g-cstyle3">l</span>paraí<span class="g-cstyle3">s</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-30" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.1677%;margin-top:-6.6px;left:35.9908%;width:78px;">
      <p class="g-pstyle6">C<span class="g-cstyle3">on</span>cepc<span class="g-cstyle3">i</span>ó<span class="g-cstyle3">n</span><span class="g-cstyle6"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-31" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.1677%;margin-top:-6.6px;left:89.7728%;width:71px;">
      <p class="g-pstyle5"><span class="g-cstyle6"> </span><span class="g-cstyle7">V</span><span class="g-cstyle5">a</span>l<span class="g-cstyle5">p</span>a<span class="g-cstyle5">r</span>a<span class="g-cstyle5">í</span>so<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-32" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.0155%;margin-top:-5.9px;left:3.5093%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle0">4</span> </p>
    </div>
    <div id="g-ai0-33" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.0155%;margin-top:-5.9px;left:55.584%;width:45px;">
      <p class="g-pstyle8"><span class="g-cstyle2">1</span>0-<span class="g-cstyle2">1</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-34" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:47.4648%;margin-top:-6.9px;left:7.7948%;width:217px;">
      <p class="g-pstyle4">P<span class="g-cstyle3">on</span>ti<span class="g-cstyle3">f</span>i<span class="g-cstyle3">c</span>i<span class="g-cstyle3">a</span> <span class="g-cstyle4">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">da</span>d C<span class="g-cstyle4">a</span>t<span class="g-cstyle3">ó</span>l<span class="g-cstyle3">i</span>c<span class="g-cstyle3">a d</span>e <span class="g-cstyle7">V</span>a<span class="g-cstyle3">l</span>p<span class="g-cstyle3">a</span>r<span class="g-cstyle3">aí</span>s<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-35" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:47.4648%;margin-top:-6.9px;left:61.0605%;width:138px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d d<span class="g-cstyle3">el </span>D<span class="g-cstyle3">e</span>sa<span class="g-cstyle3">r</span><span class="g-cstyle4">r</span><span class="g-cstyle3">oll</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-36" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:47.8263%;margin-top:-6.6px;left:36.7825%;width:67px;">
      <p class="g-pstyle5"><span class="g-cstyle7">V</span><span class="g-cstyle5">a</span>l<span class="g-cstyle5">p</span>a<span class="g-cstyle5">r</span>a<span class="g-cstyle5">í</span>so<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-37" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:47.8263%;margin-top:-6.6px;left:90.1561%;width:65px;">
      <p class="g-pstyle6"><span class="g-cstyle6"> </span>Sa<span class="g-cstyle3">n</span>tiag<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-38" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:47.6741%;margin-top:-5.9px;left:3.0092%;width:38px;">
      <p class="g-pstyle8">5-6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-39" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:47.6741%;margin-top:-5.9px;left:55.584%;width:45px;">
      <p class="g-pstyle8"><span class="g-cstyle2">1</span>0-<span class="g-cstyle2">1</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-40" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.1235%;margin-top:-6.9px;left:7.7948%;width:138px;">
      <p class="g-pstyle4"><span class="g-cstyle8">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">A</span>do<span class="g-cstyle3">lf</span>o Ibáñ<span class="g-cstyle3">e</span>z<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-41" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.1235%;margin-top:-6.9px;left:61.0605%;width:161px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d A<span class="g-cstyle3">u</span>tó<span class="g-cstyle3">n</span>oma d<span class="g-cstyle3">e</span> Chi<span class="g-cstyle3">l</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-42" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.485%;margin-top:-6.6px;left:37.1579%;width:60px;">
      <p class="g-pstyle5"><span class="g-cstyle5">S</span>an<span class="g-cstyle5">t</span>iago<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-43" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.485%;margin-top:-6.6px;left:90.1561%;width:65px;">
      <p class="g-pstyle6"><span class="g-cstyle6"> </span>Sa<span class="g-cstyle3">n</span>tiag<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-44" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.3328%;margin-top:-5.9px;left:3.0092%;width:38px;">
      <p class="g-pstyle8">5-6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-45" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:55.3328%;margin-top:-5.9px;left:55.5427%;width:46px;">
      <p class="g-pstyle8"><span class="g-cstyle2">1</span>6-20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-46" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:62.7821%;margin-top:-6.9px;left:7.7948%;width:142px;">
      <p class="g-pstyle4"><span class="g-cstyle8">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> D<span class="g-cstyle3">i</span>ego P<span class="g-cstyle3">o</span>rt<span class="g-cstyle3">a</span>l<span class="g-cstyle3">e</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-47" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:62.7821%;margin-top:-6.9px;left:61.0605%;width:162px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d B<span class="g-cstyle3">e</span>rna<span class="g-cstyle3">r</span>d<span class="g-cstyle3">o</span> <span class="g-cstyle3">O</span>&rsquo;<span class="g-cstyle3">H</span>iggi<span class="g-cstyle3">n</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-48" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.1436%;margin-top:-6.6px;left:37.1579%;width:60px;">
      <p class="g-pstyle5"><span class="g-cstyle5">S</span>an<span class="g-cstyle5">t</span>iago<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-49" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:63.1436%;margin-top:-6.6px;left:90.1561%;width:65px;">
      <p class="g-pstyle6"><span class="g-cstyle6"> </span>Sa<span class="g-cstyle3">n</span>tiag<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-50" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:62.9914%;margin-top:-5.9px;left:3.0174%;width:37px;">
      <p class="g-pstyle8">7-9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-51" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:62.9914%;margin-top:-5.9px;left:55.5427%;width:46px;">
      <p class="g-pstyle8"><span class="g-cstyle2">1</span>6-20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-52" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.6596%;margin-top:-6.9px;left:7.7948%;width:209px;">
      <p class="g-pstyle4"><span class="g-cstyle8">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle10">T</span>é<span class="g-cstyle3">cn</span>i<span class="g-cstyle3">ca</span> Fe<span class="g-cstyle3">d</span>e<span class="g-cstyle3">r</span>ico Sant<span class="g-cstyle3">a</span> <span class="g-cstyle3">M</span>a<span class="g-cstyle3">r</span>ía <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-53" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.6596%;margin-top:-6.9px;left:61.0605%;width:156px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d <span class="g-cstyle3">C</span><span class="g-cstyle4">a</span><span class="g-cstyle3">t</span>ó<span class="g-cstyle3">l</span>i<span class="g-cstyle3">c</span>a d<span class="g-cstyle3">el</span> No<span class="g-cstyle3">r</span>t<span class="g-cstyle3">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-54" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.0211%;margin-top:-6.6px;left:36.7825%;width:67px;">
      <p class="g-pstyle5"><span class="g-cstyle7">V</span><span class="g-cstyle5">a</span>l<span class="g-cstyle5">p</span>a<span class="g-cstyle5">r</span>a<span class="g-cstyle5">í</span>so<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-55" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.0211%;margin-top:-6.6px;left:89.3564%;width:79px;">
      <p class="g-pstyle6"><span class="g-cstyle6"> </span>A<span class="g-cstyle3">n</span>t<span class="g-cstyle4">o</span>f<span class="g-cstyle3">a</span>ga<span class="g-cstyle3">s</span>t<span class="g-cstyle3">a</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-56" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.8689%;margin-top:-5.9px;left:3.0174%;width:37px;">
      <p class="g-pstyle8">7-9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-57" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.8689%;margin-top:-5.9px;left:55.5427%;width:46px;">
      <p class="g-pstyle8"><span class="g-cstyle2">1</span>6-20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-58" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.3183%;margin-top:-6.9px;left:7.7948%;width:135px;">
      <p class="g-pstyle4"><span class="g-cstyle8">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> l</span>os A<span class="g-cstyle3">n</span>des<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-59" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.3183%;margin-top:-6.9px;left:61.0605%;width:136px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d d<span class="g-cstyle3">e </span>La S<span class="g-cstyle3">e</span><span class="g-cstyle8">r</span>e<span class="g-cstyle3">n</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-60" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.6797%;margin-top:-6.6px;left:37.1579%;width:60px;">
      <p class="g-pstyle5"><span class="g-cstyle5">S</span>an<span class="g-cstyle5">t</span>iago<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-61" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.6797%;margin-top:-6.6px;left:89.9235%;width:70px;">
      <p class="g-pstyle6"><span class="g-cstyle6"> </span>L<span class="g-cstyle3">a</span> S<span class="g-cstyle3">e</span><span class="g-cstyle4">r</span><span class="g-cstyle3">e</span>na<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-62" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.5275%;margin-top:-5.9px;left:3.0174%;width:37px;">
      <p class="g-pstyle8">7-9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-63" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.5275%;margin-top:-5.9px;left:55.5427%;width:46px;">
      <p class="g-pstyle8"><span class="g-cstyle2">1</span>6-20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-64" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:85.9769%;margin-top:-6.9px;left:7.7948%;width:133px;">
      <p class="g-pstyle4"><span class="g-cstyle8">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">A</span>nd<span class="g-cstyle4">r</span><span class="g-cstyle3">és</span> Be<span class="g-cstyle3">l</span>lo<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-65" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:85.9769%;margin-top:-6.9px;left:61.0605%;width:125px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d d<span class="g-cstyle3">el </span>Bí<span class="g-cstyle3">o</span><span class="g-cstyle12">-</span>B<span class="g-cstyle3">í</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-66" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:86.3384%;margin-top:-6.6px;left:37.1579%;width:60px;">
      <p class="g-pstyle5"><span class="g-cstyle5">S</span>an<span class="g-cstyle5">t</span>iago<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-67" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:86.3384%;margin-top:-6.6px;left:89.2573%;width:78px;">
      <p class="g-pstyle6"><span class="g-cstyle6"> </span>C<span class="g-cstyle3">o</span>nc<span class="g-cstyle3">ep</span>c<span class="g-cstyle3">ió</span>n<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-68" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:86.1861%;margin-top:-5.9px;left:2.4504%;width:45px;">
      <p class="g-pstyle8">10-15<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-69" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:86.1861%;margin-top:-5.9px;left:55.5427%;width:46px;">
      <p class="g-pstyle8"><span class="g-cstyle2">1</span>6-20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-70" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:94.1493%;margin-top:-7.3px;left:0.4583%;width:197px;">
      <p class="g-pstyle9">(<span class="g-cstyle3">*</span>) <span class="g-cstyle13">F</span>u<span class="g-cstyle3">e</span>n<span class="g-cstyle3">t</span>e: <span class="g-cstyle3">w</span>w<span class="g-cstyle12">w</span><span class="g-cstyle14">.</span>t<span class="g-cstyle3">o</span>pun<span class="g-cstyle3">i</span>v<span class="g-cstyle3">e</span>rs<span class="g-cstyle3">i</span>tie<span class="g-cstyle3">s</span>.com<span class="g-cstyle1"> </span></p>
    </div>
  </div>

  <!-- Artboard: mobile -->
  <div id="g-03-qs-world-chilenos-mobile" class="g-artboard" style="max-width: 320px;max-height: 967px" data-aspect-ratio="0.331" data-min-width="0" data-max-width="799">
<div style="padding: 0 0 302.1875% 0;"></div>
    <img id="g-03-qs-world-chilenos-mobile-img" class="g-aiImg" alt="" src="${img1}"/>
    <div id="g-ai1-1" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:3.6734%;margin-top:-22.5px;left:2.4167%;width:228px;">
      <p class="g-pstyle0">QS <span class="g-cstyle0">W</span>ORLD<span class="g-cstyle0"> </span>U<span class="g-cstyle0">N</span>IV<span class="g-cstyle0">E</span>RSI<span class="g-cstyle0">TY</span> </p>
      <p class="g-pstyle0">RANKI<span class="g-cstyle0">N</span>GS 202<span class="g-cstyle1">2</span></p>
    </div>
    <div id="g-ai1-2" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:7.2081%;margin-top:-8.7px;left:23.5129%;width:83px;">
      <p class="g-pstyle1"><span class="g-cstyle2">I</span>ns<span class="g-cstyle2">t</span>i<span class="g-cstyle2">t</span>u<span class="g-cstyle2">c</span>ió<span class="g-cstyle1">n</span></p>
    </div>
    <div id="g-ai1-3" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:7.177%;margin-top:-7.4px;left:4.0015%;width:73px;">
      <p class="g-pstyle2">RA<span class="g-cstyle0">N</span>KI<span class="g-cstyle0">N</span>G<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-4" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:7.0943%;margin-top:-6.6px;left:78.6058%;width:54px;">
      <p class="g-pstyle3">Ciuda<span class="g-cstyle1">d</span></p>
    </div>
    <div id="g-ai1-5" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:8.3146%;margin-top:-7.4px;left:2.7805%;width:78px;">
      <p class="g-pstyle2"><span class="g-cstyle0">N</span>ACIO<span class="g-cstyle0">N</span>A<span class="g-cstyle1">L</span></p>
    </div>
    <div id="g-ai1-6" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:11.6332%;margin-top:-14.5px;left:23.4891%;width:130px;">
      <p class="g-pstyle4">P<span class="g-cstyle3">on</span>ti<span class="g-cstyle3">f</span>i<span class="g-cstyle3">c</span>i<span class="g-cstyle3">a</span> <span class="g-cstyle4">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">da</span>d</p>
      <p class="g-pstyle5"><span class="g-cstyle5">C</span><span class="g-cstyle4">a</span><span class="g-cstyle5">t</span>ó<span class="g-cstyle5">l</span>i<span class="g-cstyle5">c</span>a d<span class="g-cstyle5">e Ch</span>ile<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-7" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:11.7789%;margin-top:-7.9px;left:76.7488%;width:66px;">
      <p class="g-pstyle6"><span class="g-cstyle5">S</span>an<span class="g-cstyle5">t</span>iago<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-8" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:11.7478%;margin-top:-6.6px;left:11.286%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle0">1</span> </p>
    </div>
    <div id="g-ai1-9" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:15.8016%;margin-top:-7.8px;left:23.4891%;width:128px;">
      <p class="g-pstyle4"><span class="g-cstyle6">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span>Chi<span class="g-cstyle3">l</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-10" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.0188%;margin-top:-7.9px;left:76.7488%;width:66px;">
      <p class="g-pstyle6"><span class="g-cstyle5">S</span>an<span class="g-cstyle5">t</span>iago<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-11" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:15.8843%;margin-top:-6.6px;left:11.2149%;width:30px;">
      <p class="g-pstyle7"><span class="g-cstyle0">2</span> </p>
    </div>
    <div id="g-ai1-12" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.8028%;margin-top:-14.5px;left:23.4891%;width:112px;">
      <p class="g-pstyle4"><span class="g-cstyle6">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span></p>
      <p class="g-pstyle4">Sa<span class="g-cstyle3">n</span>t<span class="g-cstyle3">i</span>ag<span class="g-cstyle3">o</span> de <span class="g-cstyle3">C</span>hi<span class="g-cstyle3">l</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-13" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:20.1553%;margin-top:-7.9px;left:76.7488%;width:66px;">
      <p class="g-pstyle6"><span class="g-cstyle5">S</span>an<span class="g-cstyle5">t</span>iago<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-14" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:20.1243%;margin-top:-6.6px;left:11.239%;width:31px;">
      <p class="g-pstyle7"><span class="g-cstyle0">3</span> </p>
    </div>
    <div id="g-ai1-15" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:24.0427%;margin-top:-14.5px;left:23.4891%;width:100px;">
      <p class="g-pstyle4"><span class="g-cstyle6">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span></p>
      <p class="g-pstyle4">Co<span class="g-cstyle3">n</span>cep<span class="g-cstyle3">c</span>ió<span class="g-cstyle3">n</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-16" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:24.3952%;margin-top:-7.9px;left:73.605%;width:86px;">
      <p class="g-pstyle8">C<span class="g-cstyle3">on</span>cepc<span class="g-cstyle3">i</span>ó<span class="g-cstyle3">n</span><span class="g-cstyle7"> </span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-17" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:24.2608%;margin-top:-6.6px;left:11.1679%;width:31px;">
      <p class="g-pstyle7"><span class="g-cstyle0">4</span> </p>
    </div>
    <div id="g-ai1-18" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:28.0758%;margin-top:-14.5px;left:23.4891%;width:135px;">
      <p class="g-pstyle4">P<span class="g-cstyle3">on</span>ti<span class="g-cstyle3">f</span>i<span class="g-cstyle3">c</span>i<span class="g-cstyle3">a</span> <span class="g-cstyle4">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">da</span>d </p>
      <p class="g-pstyle5"><span class="g-cstyle5">C</span><span class="g-cstyle4">a</span><span class="g-cstyle5">t</span>ó<span class="g-cstyle5">l</span>i<span class="g-cstyle5">c</span>a d<span class="g-cstyle5">e </span><span class="g-cstyle8">V</span><span class="g-cstyle5">a</span>l<span class="g-cstyle5">p</span>a<span class="g-cstyle5">r</span>aí<span class="g-cstyle5">s</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-19" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:28.5317%;margin-top:-7.9px;left:75.5885%;width:74px;">
      <p class="g-pstyle6"><span class="g-cstyle8">V</span><span class="g-cstyle5">a</span>l<span class="g-cstyle5">p</span>a<span class="g-cstyle5">r</span>a<span class="g-cstyle5">í</span>so<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-20" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:28.5007%;margin-top:-6.6px;left:9.7299%;width:40px;">
      <p class="g-pstyle9">5-6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-21" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:32.4191%;margin-top:-14.5px;left:23.4891%;width:94px;">
      <p class="g-pstyle4"><span class="g-cstyle6">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> </p>
      <p class="g-pstyle4"><span class="g-cstyle3">A</span>do<span class="g-cstyle3">lf</span>o Ibáñ<span class="g-cstyle3">e</span>z<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-22" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:32.7716%;margin-top:-7.9px;left:76.7488%;width:66px;">
      <p class="g-pstyle6"><span class="g-cstyle5">S</span>an<span class="g-cstyle5">t</span>iago<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-23" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:32.7406%;margin-top:-6.6px;left:9.7299%;width:40px;">
      <p class="g-pstyle9">5-6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-24" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:36.6591%;margin-top:-14.5px;left:23.4891%;width:98px;">
      <p class="g-pstyle4"><span class="g-cstyle6">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> </p>
      <p class="g-pstyle4">D<span class="g-cstyle3">i</span>ego P<span class="g-cstyle3">o</span>rt<span class="g-cstyle3">a</span>l<span class="g-cstyle3">e</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-25" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:37.0116%;margin-top:-7.9px;left:76.7488%;width:66px;">
      <p class="g-pstyle6"><span class="g-cstyle5">S</span>an<span class="g-cstyle5">t</span>iago<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-26" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:36.8771%;margin-top:-6.6px;left:9.7534%;width:40px;">
      <p class="g-pstyle9">7-9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-27" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.6922%;margin-top:-14.5px;left:23.4891%;width:133px;">
      <p class="g-pstyle4"><span class="g-cstyle6">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle9">T</span>é<span class="g-cstyle3">cn</span>i<span class="g-cstyle3">ca</span> </p>
      <p class="g-pstyle4">Fe<span class="g-cstyle3">d</span>e<span class="g-cstyle3">r</span>ico Sant<span class="g-cstyle3">a</span> <span class="g-cstyle3">M</span>a<span class="g-cstyle3">r</span>ía <span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-28" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:41.1481%;margin-top:-7.9px;left:75.5885%;width:74px;">
      <p class="g-pstyle6"><span class="g-cstyle8">V</span><span class="g-cstyle5">a</span>l<span class="g-cstyle5">p</span>a<span class="g-cstyle5">r</span>a<span class="g-cstyle5">í</span>so<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-29" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:41.117%;margin-top:-6.6px;left:9.7534%;width:40px;">
      <p class="g-pstyle9">7-9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-30" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:45.0355%;margin-top:-14.5px;left:23.4891%;width:100px;">
      <p class="g-pstyle4"><span class="g-cstyle6">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span></p>
      <p class="g-pstyle4"><span class="g-cstyle3">l</span>os A<span class="g-cstyle3">n</span>des<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-31" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:45.388%;margin-top:-7.9px;left:76.7488%;width:66px;">
      <p class="g-pstyle6"><span class="g-cstyle5">S</span>an<span class="g-cstyle5">t</span>iago<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-32" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:45.2535%;margin-top:-6.6px;left:9.7534%;width:40px;">
      <p class="g-pstyle9">7-9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-33" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:49.172%;margin-top:-14.5px;left:23.4891%;width:87px;">
      <p class="g-pstyle4"><span class="g-cstyle6">U</span><span class="g-cstyle3">n</span>ive<span class="g-cstyle3">r</span>si<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> </p>
      <p class="g-pstyle4"><span class="g-cstyle3">A</span>nd<span class="g-cstyle4">r</span><span class="g-cstyle3">és</span> Be<span class="g-cstyle3">l</span>lo<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-34" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:49.5245%;margin-top:-7.9px;left:76.7488%;width:66px;">
      <p class="g-pstyle6"><span class="g-cstyle5">S</span>an<span class="g-cstyle5">t</span>iago<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-35" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:49.4934%;margin-top:-6.6px;left:8.1232%;width:49px;">
      <p class="g-pstyle9">10-15<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-36" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:53.3085%;margin-top:-14.5px;left:23.8936%;width:122px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d A<span class="g-cstyle3">u</span>str<span class="g-cstyle3">a</span>l </p>
      <p class="g-pstyle5"><span class="g-cstyle5">d</span>e<span class="g-cstyle5"> C</span>h<span class="g-cstyle5">i</span>le<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-37" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:53.5576%;margin-top:-7.9px;left:76.7279%;width:66px;">
      <p class="g-pstyle8"><span class="g-cstyle7"> </span><span class="g-cstyle8">V</span>a<span class="g-cstyle3">l</span>div<span class="g-cstyle3">i</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-38" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:53.4231%;margin-top:-6.6px;left:8.1477%;width:49px;">
      <p class="g-pstyle9"><span class="g-cstyle2">1</span>0-<span class="g-cstyle2">1</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-39" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:57.3416%;margin-top:-14.5px;left:23.8936%;width:97px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d d<span class="g-cstyle3">e</span></p>
      <p class="g-pstyle4">La <span class="g-cstyle10">F</span><span class="g-cstyle6">r</span><span class="g-cstyle3">o</span>nt<span class="g-cstyle3">e</span>ra<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-40" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:57.6941%;margin-top:-7.9px;left:76.5157%;width:68px;">
      <p class="g-pstyle8"><span class="g-cstyle7"> </span><span class="g-cstyle9">T</span>emuc<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-41" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:57.663%;margin-top:-6.6px;left:8.1477%;width:49px;">
      <p class="g-pstyle9"><span class="g-cstyle2">1</span>0-<span class="g-cstyle2">1</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-42" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:61.6134%;margin-top:-7.8px;left:23.8936%;width:129px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d d<span class="g-cstyle3">e </span><span class="g-cstyle11">T</span>a<span class="g-cstyle3">lc</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-43" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:61.934%;margin-top:-7.9px;left:78.5316%;width:55px;">
      <p class="g-pstyle8"><span class="g-cstyle7"> </span><span class="g-cstyle11">T</span>a<span class="g-cstyle3">l</span>ca<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-44" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:61.903%;margin-top:-6.6px;left:8.1477%;width:49px;">
      <p class="g-pstyle9"><span class="g-cstyle2">1</span>0-<span class="g-cstyle2">1</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-45" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:65.6146%;margin-top:-14.5px;left:23.8936%;width:100px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d d<span class="g-cstyle3">e </span></p>
      <p class="g-pstyle4"><span class="g-cstyle8">V</span>a<span class="g-cstyle3">l</span>paraí<span class="g-cstyle3">s</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-46" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:66.0705%;margin-top:-7.9px;left:74.7778%;width:79px;">
      <p class="g-pstyle6"><span class="g-cstyle7"> </span><span class="g-cstyle8">V</span><span class="g-cstyle5">a</span>l<span class="g-cstyle5">p</span>a<span class="g-cstyle5">r</span>a<span class="g-cstyle5">í</span>so<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-47" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:66.0395%;margin-top:-6.6px;left:8.1477%;width:49px;">
      <p class="g-pstyle9"><span class="g-cstyle2">1</span>0-<span class="g-cstyle2">1</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-48" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:69.9579%;margin-top:-14.5px;left:23.8936%;width:102px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d d<span class="g-cstyle3">el </span></p>
      <p class="g-pstyle5"><span class="g-cstyle5">D</span>e<span class="g-cstyle5">sa</span>r<span class="g-cstyle4">r</span>oll<span class="g-cstyle5">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-49" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.3104%;margin-top:-7.9px;left:75.9317%;width:71px;">
      <p class="g-pstyle8"><span class="g-cstyle7"> </span>Sa<span class="g-cstyle3">n</span>tiag<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-50" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:70.2794%;margin-top:-6.6px;left:8.1477%;width:49px;">
      <p class="g-pstyle9"><span class="g-cstyle2">1</span>0-<span class="g-cstyle2">1</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-51" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:74.4047%;margin-top:-14.5px;left:23.8936%;width:138px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d A<span class="g-cstyle3">u</span>tó<span class="g-cstyle3">n</span>oma </p>
      <p class="g-pstyle4">d<span class="g-cstyle3">e</span> Chi<span class="g-cstyle3">l</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-52" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:74.5503%;margin-top:-7.9px;left:75.9317%;width:71px;">
      <p class="g-pstyle8"><span class="g-cstyle7"> </span>Sa<span class="g-cstyle3">n</span>tiag<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-53" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:74.4159%;margin-top:-6.6px;left:8.0293%;width:50px;">
      <p class="g-pstyle9"><span class="g-cstyle2">1</span>6-20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-54" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.4378%;margin-top:-14.5px;left:23.8936%;width:121px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d </p>
      <p class="g-pstyle4">B<span class="g-cstyle3">e</span>rna<span class="g-cstyle3">r</span>d<span class="g-cstyle3">o</span> <span class="g-cstyle3">O</span>&rsquo;<span class="g-cstyle3">H</span>iggi<span class="g-cstyle3">n</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-55" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.6869%;margin-top:-7.9px;left:75.9317%;width:71px;">
      <p class="g-pstyle8"><span class="g-cstyle7"> </span>Sa<span class="g-cstyle3">n</span>tiag<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-56" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:78.6558%;margin-top:-6.6px;left:8.0293%;width:50px;">
      <p class="g-pstyle9"><span class="g-cstyle2">1</span>6-20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-57" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:82.6777%;margin-top:-14.5px;left:23.8936%;width:114px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d </p>
      <p class="g-pstyle4"><span class="g-cstyle3">C</span><span class="g-cstyle4">a</span><span class="g-cstyle3">t</span>ó<span class="g-cstyle3">l</span>i<span class="g-cstyle3">c</span>a d<span class="g-cstyle3">el</span> No<span class="g-cstyle3">r</span>t<span class="g-cstyle3">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-58" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:82.9268%;margin-top:-7.9px;left:73.4384%;width:87px;">
      <p class="g-pstyle8"><span class="g-cstyle7"> </span>A<span class="g-cstyle3">n</span>t<span class="g-cstyle4">o</span>f<span class="g-cstyle3">a</span>ga<span class="g-cstyle3">s</span>t<span class="g-cstyle3">a</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-59" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:82.7923%;margin-top:-6.6px;left:8.0293%;width:50px;">
      <p class="g-pstyle9"><span class="g-cstyle2">1</span>6-20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-60" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:86.9176%;margin-top:-14.5px;left:23.8936%;width:100px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d d<span class="g-cstyle3">e </span></p>
      <p class="g-pstyle4">La S<span class="g-cstyle3">e</span><span class="g-cstyle6">r</span>e<span class="g-cstyle3">n</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-61" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:87.0633%;margin-top:-7.9px;left:75.0447%;width:77px;">
      <p class="g-pstyle8"><span class="g-cstyle7"> </span>L<span class="g-cstyle3">a</span> S<span class="g-cstyle3">e</span><span class="g-cstyle4">r</span><span class="g-cstyle3">e</span>na<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-62" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:87.0322%;margin-top:-6.6px;left:8.0293%;width:50px;">
      <p class="g-pstyle9"><span class="g-cstyle2">1</span>6-20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-63" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:91.0541%;margin-top:-14.5px;left:23.8936%;width:84px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">i</span>ve<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d </p>
      <p class="g-pstyle5"><span class="g-cstyle5">d</span>el <span class="g-cstyle5">Bí</span>o<span class="g-cstyle12">-</span><span class="g-cstyle5">B</span>í<span class="g-cstyle5">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-64" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:91.3032%;margin-top:-7.9px;left:73.6067%;width:86px;">
      <p class="g-pstyle8"><span class="g-cstyle7"> </span>C<span class="g-cstyle3">o</span>nc<span class="g-cstyle3">ep</span>c<span class="g-cstyle3">ió</span>n<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-65" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:91.2721%;margin-top:-6.6px;left:8.0293%;width:50px;">
      <p class="g-pstyle9"><span class="g-cstyle2">1</span>6-20<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-66" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:96.5111%;margin-top:-7.3px;left:5.2083%;width:197px;">
      <p class="g-pstyle4">(<span class="g-cstyle3">*</span>) <span class="g-cstyle13">F</span>u<span class="g-cstyle3">e</span>n<span class="g-cstyle3">t</span>e: <span class="g-cstyle3">w</span>w<span class="g-cstyle12">w</span><span class="g-cstyle14">.</span>t<span class="g-cstyle3">o</span>pun<span class="g-cstyle3">i</span>v<span class="g-cstyle3">e</span>rs<span class="g-cstyle3">i</span>tie<span class="g-cstyle3">s</span>.com<span class="g-cstyle1"> </span></p>
    </div>
  </div>


</div>
`

const containerId = 'g-03-qs-world-chilenos-box'
const namespace = 'g-'
const name = '03-qs-world-chilenos'

export default makeAi2React({ html, styles, containerId, namespace, name })

/* End ai2react - 2021-09-14 03:18 */
